<template lang="pug">
  .form-success
    .form-success__wrapper
      .form-success__title
        .h2
          span.h2__wrapper.h2__wrapper-center(v-html="h2")
      .form-success__text
        p(v-html="description")
</template>

<script>
export default {
  name: 'AppFormSuccess',

  data () {
    return {
      h2: 'Заявка отправлена!',
      description: 'В ближайшее время с вами свяжется<br>наш специалист.'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/AppFormSuccess.vue